// Custom Proudct Header
document.addEventListener("DOMContentLoaded", function () {
    let collectionHeading = document.querySelector(".collection-banner .collection-banner__heading");
    let url = new URL(window.location.href);
    //https://modsdirect.myshopify.com/collections/all/2013-mercedes-amg-a45-esi6845754
    let path = url.pathname.split('/')// split the path into segments


    if (path[1] === 'collections' && path[2] === 'all' && path.length > 3) {
        let lastDirectory = path[path.length - 1];
        let parts = lastDirectory.split('-');

        // remove the 'esi' part from the last segment
        parts[parts.length - 1] = parts[parts.length - 1].replace(/esi.*/, '');

        // capitalize each part and join them back together
        let result = parts.map((part, index) => {
            // if it's the last part, make it uppercase
            if (index === parts.length - 1) {
                return part.toUpperCase();
            } else {
                // capitalize the first letter of the part
                return part.charAt(0).toUpperCase() + part.slice(1).toUpperCase();
            }
        }).join(' ');
        console.log('the result is ', result)
        collectionHeading.textContent = 'Products for ' + result;
    }

    // if (windowUrl)

    // if (collectionHeading && window.location.href.indexOf("-es") > -1) {
    // }
});